/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-04-15 19:46:00
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-07-29 11:22:49
 */
import React, { PureComponent } from 'react';
import { GlobalStyled } from './style.js';
// import Chat from './components/Pages/--Chat/ChatUI/index'
import './index.css' //这句话必须要加 至于为什么我也不清楚(主要是里面的@import '~antd/dist/antd.css';) ，明明index.js里面已经加过了

import store from './store';
import { Provider } from 'react-redux'
import { Route, Redirect, Switch, BrowserRouter, HashRouter } from 'react-router-dom'
import { registerAuthRules } from './utils/hoc-auth-master'
import Main from './components/Pages/mainWindow'
import { hasCookie, removeCookie, getCookie } from './utils/checkCookie'
import { KEY_LOGIN_STATE, KEY_USERNAME } from './utils/cookieValue'
import zhCN from 'antd/es/locale/zh_CN'
import { ConfigProvider } from 'antd'
// import Router from 'src/router'
import 'moment/locale/zh-cn'
class App extends PureComponent {
  componentWillUnmount() {
    if (global.client) {
      try {
        global.client.destroy()
      } catch (error) {
        console.log(error);
      }
    }
  }
  render() {
    return (<ConfigProvider locale={zhCN}>
      <Provider store={store}>
        <GlobalStyled />
        <HashRouter >
          {/* <div style={{ height: '100%' }}> */}
          <div>
            <Main />
          </div>
        </HashRouter>
      </Provider>
    </ConfigProvider>
    )
  }
}

export default App;
